module.exports = __webpack_public_path__ + "img/VN old.fe680431.png";